<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Quote for TIDY'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form>
    <tidy-wrapper>


      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage"
          />
      }

      <tidy-row [align]="'center'">
        <tidy-text
          [title]="name" />
      </tidy-row>

      <tidy-row [align]="'center'" class="extra-bottom-padding">
        <tidy-text
          [body]="'We are delighted to start! Our goal is to help you dramatically improve your cleaning and maintenance management. Please complete this and our team of experts will get to work.'" />
      </tidy-row>

      @if (showResponsibilities) {
        <tidy-card>
          <tidy-row>
            <tidy-text
              [header]="'TIDY\'s Responsibilities'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'TIDY shall:'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="'<li>Provide software and human services to help make managing of cleaning and maintenance better.</li>'" />
            <tidy-text
              [body]="'<li>Suggest how to improve quality, reduce costs, or avoid issues.</li>'" />
            <tidy-text
              [body]="'<li>Provide automations to save time.</li>'" />
            <tidy-text
              [body]="'<li>Provide support to your team and your pros.</li>'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'TIDY cannot:'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'<li>We cannot guarantee results from on-site third-party vendors, as everything about your management is custom to you. We
              do give guidance and want you to succeed.</li>'" />
            <tidy-text
              [body]="'<li>We cannot personally do anything on-site.'" />
        </tidy-row>
      </tidy-card>
      <tidy-card>
        <tidy-row>
          <tidy-text
            [header]="'Client\'s Responsibilities'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
              [body]="'We are most successful when we work together with clients to understand and automate your cleaning and maintenance
              workflows. We need your help:'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'<li>Giving us the information we need to set up and manage your account.</li>'" />
          <tidy-text
              [body]="'<li>Ensure you give us any/all pros you have ever found as acceptable, even if not preferred. Customers that provide us with
              an existing vendor are 10x more likely to be successful, so we require customers to add at least 1 or request a waiver.</li>'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Additionally you can view the terms and conditions '" />
        <tidy-text
          class="link"
          (action)="goToTermsAndConditions()"
          [actionBody]="'here.'" />
      </tidy-row>
    </tidy-card>
  }

  <tidy-card>
    <tidy-row class="vertical-align-center">
      <tidy-image
        [src]="'assets/img/rental-property.svg'"
        style="width: 30px" />
      <tidy-text
        [title]="plan" />
    </tidy-row>
    <tidy-row>
      <tidy-text
        [body]="('Cost: ' | translate) + planCost" />
    </tidy-row>
    <tidy-row class="extra-bottom-padding">
      <tidy-text
        [body]="('Description: ' | translate) + planCostDescription" />
    </tidy-row>
    <tidy-row class="vertical-align-center extra-top-padding">
      <tidy-image
        [src]="'assets/img/concierge.svg'"
        class="title-size" />
      <tidy-text
        [header]="'Onboarding'" />
    </tidy-row>
    <tidy-row>
      <tidy-text
        [body]="'TIDY shall help with any account setup, data loading, team training, or other work to get the account set up correctly for you. We will do whatever it takes to get you set up for success, use us!'" />
    </tidy-row>
    <tidy-row>
      <tidy-text
        [body]="('Customer\’s onboarding fees: ' | translate) + onboardingCost" />
    </tidy-row>
    <tidy-row class="extra-top-padding extra-bottom-padding">
      <tidy-divider />
    </tidy-row>
    <tidy-row class="vertical-align-center">
      <tidy-image
        [src]="'assets/img/money-back-guarantee.svg'"
        class="title-size" />
      <tidy-text
        [header]="'Money Back Guarantee'" />
    </tidy-row>
    <tidy-row>
      <tidy-text
        [body]="'TIDY shall deliver your money back on subscriptions if you are unhappy for any reason and cancel within 14 days. Note that payments sent to pros for jobs cannot be refunded with this guarantee.'" />
    </tidy-row>
    <tidy-row class="extra-top-padding extra-bottom-padding">
      <tidy-divider />
    </tidy-row>
    <tidy-row class="vertical-align-center">
      <tidy-image
        [src]="'assets/img/hourglass.svg'"
        class="title-size" />
      <tidy-text
        [header]="'Deadline'" />
    </tidy-row>
    <tidy-row>
      <tidy-text
        [body]="('This offer is valid through ' | translate) + deadline" />
    </tidy-row>
  </tidy-card>

  <tidy-row>
    <tidy-text
      [header]="'Next Steps'" /><br>
    <tidy-text
      [body]="getStartedText" />
  </tidy-row>

  <tidy-card>
    <tidy-row>
      <tidy-text
        [header]="'Enter Card Information'" />
    </tidy-row>

    <div class="form-row">
      <div id="card-info" #cardInfo></div>
    </div>

    <tidy-error-message
      [text]="errorMessage" />
  </tidy-card>

  <ng-container>
    <div style="display: flex; align-content: center; justify-content: center;">
      <re-captcha (resolved)="captchaEvents($event)" />
    </div>
  </ng-container>

  <tidy-row>
    <tidy-button
      [text]="'I Agree'"
      [action]="boundSubmitCard"
      class="primary" />
  </tidy-row>

</tidy-wrapper>
</form>
</ng-template>

<app-scroll-wrapper [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />
